// eslint-disable-next-line import/prefer-default-export
export const getManagersState = (state) => state.managers;
